
    <div class="device-reading-widget" *ngIf="!entity">
      <widget-spinner></widget-spinner>
    </div>
    <div class="device-reading-widget" *ngIf="entity">
            [PENDING]
    </div>
  